import React, { useEffect } from 'react'
import FilterIcon from '../../../assets/svg/FilterIcon'
import { AiOutlineClose } from 'react-icons/ai'
import styles from './filter.module.css'

const FilterButton = ({
    handleOpenModal,
    clearBtn,
    handleClearAllFilteredData,
}) => {
    useEffect(() => {}, [clearBtn])
    return (
        <>
            <button
                onClick={handleOpenModal}
                className={`btn btn-outline-secondary ${styles.filterIcon} ${
                    clearBtn && styles.clearFilter
                }`}
            >
                <FilterIcon className="me-2" />
                <span
                    className={` d-inline-block ${
                        clearBtn ? 'mx-2' : 'ms-1'
                    }  my-0`}
                >
                    Filter
                </span>
                {clearBtn && (
                    <span
                        className={`${styles.clearFilterCross} ps-2 my-0 d-inline-block`}
                        role="button"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleClearAllFilteredData()
                        }}
                    >
                        <AiOutlineClose size={14} />
                    </span>
                )}
            </button>
        </>
    )
}

export default FilterButton
